import {
  GetWalletListDTO,
  CreateWalletDTO,
  GetWeb3VaultAccountDetailDTO,
  WalletItemModel,
  Web3WalletItemModel,
  GetVaultAccountDetailDTO,
  WalletPaginationModel,
  WalletAssetsModel,
  SetAccountHiddenStatusDTO,
} from './models'
import { DEFAULT_WALLET_LIST_PAGE_SIZE } from '@/constants'
import WalletBaseApi from './base'

class WalletApi extends WalletBaseApi {
  async getWalletList(dto: GetWalletListDTO) {
    return this.post<WalletPaginationModel>('/findAccountByPage', {
      pageSize: DEFAULT_WALLET_LIST_PAGE_SIZE,
      ...dto,
    })
  }
  async getHideWalletList(dto: GetWalletListDTO) {
    return this.post<WalletPaginationModel>('/findHiddenAccountByPage', {
      pageSize: DEFAULT_WALLET_LIST_PAGE_SIZE,
      ...dto,
    })
  }
  async createWallet(dto: CreateWalletDTO) {
    return this.post('/addAccountV2', dto)
  }

  async getTotalBalance() {
    return this.post<WalletAssetsModel>('/getTotalBalanceByWorkspace')
  }

  async getVaultAccountDetail(dto: GetVaultAccountDetailDTO) {
    return this.post<WalletItemModel>('/getVaultAccountDetail', dto)
  }

  async getWeb3VaultAccountDetail(dto: GetWeb3VaultAccountDetailDTO) {
    return this.post<Web3WalletItemModel>('/getWeb3VaultAccountDetail', dto)
  }
  // 下载地址恢复文件
  // 响应较慢，延长响应时间
  async sendAddressRecoveryFile() {
    return this.post<boolean>('/sendAddressRecoveryFile')
  }
  // 是否可点击下载备份文件
  async isSendAddressRecoveryFile() {
    return this.post<boolean>('/isSendAddressRecoveryFile')
  }
  // 修改钱包隐藏状态
  async setAccountHiddenStatus(dto: SetAccountHiddenStatusDTO) {
    return this.post<boolean>('/setAccountHiddenStatus', dto)
  }
}

export default new WalletApi()
